export const msalConfig = {
    auth: {
        clientId: '310afbae-fb6c-477d-9616-d908cd92e371',
        authority: 'https://login.microsoftonline.com/aefd9fb6-b45d-4fb6-ae1b-58545d098f8e',
        redirectUri: window.location.origin + '/admin-login',
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    }
};

export const loginRequest = {
    scopes: ['User.Read']
};